/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import React from 'react';
import { useTranslation } from 'react-i18next';
import DashboardIcon from '@material-ui/icons/Dashboard';
import Minicard from '../../common/Minicard';
import SignIcon from '../../icons/SignIcon';

/**
 * Confirmation preview top sidebar fixed cards for extra large screens.
 */
export default function ConfirmationPreviewFixedCards({
  className,
  previewObject,
  handleReceiptClick,
  handleSignaturesClick,
  handleSummaryClick,
}) {
  const { t } = useTranslation();

  return (
    <div className={className}>
      <Minicard
        key="receipt"
        icon={<PictureAsPdfIcon fontSize="small" />}
        title={t('Receipt')}
        onClick={handleReceiptClick}
        isActive={previewObject?.id === 'receipt'}
      />

      <Minicard
        key="signature"
        icon={<SignIcon />}
        title={t('submission.signatures')}
        onClick={handleSignaturesClick}
        isActive={previewObject?.id === 'signature'}
      />

      <Minicard
        key="summary"
        icon={<DashboardIcon fontSize="small" />}
        title={t('Summary')}
        onClick={handleSummaryClick}
        isActive={previewObject?.id === 'summary'}
      />
    </div>
  );
}
